export default __webpack_public_path__ + "static/media/zodiac02.d8c422a6.png";